import styled from 'styled-components';

export const StyledPlatformsCheck = styled.ul`
  display: flex;
  flex-direction: row;
`;

